export const referenceCompanyEditorSections = [["overview","Temel bilgiler"],["content","Detay içeriği"],["relations","Bağlı vakalar"],["seo","SEO"],["preview","Önizleme"]] as const;
